import React from "react";
import { VehSingleDropDown } from "../../generic/input";
import { Col } from "react-bootstrap";
import { timeFormat, toLocaleDateString } from "../../lib/dtconv";

const TesterPanel = require("dev_tools").default;

export default class Debugger extends React.Component {
  constructor(props) {
    super(props);
    this.connectRef = React.createRef();

    this.state = { selectedVehicle: null, pickerTitle: "Select Vehicle" };
    this.lastPingMap = {};
  }

  componentDidMount() {
    if (global.bikeDetails) this.onBikes(global.bikeDetails);
    global.EE.addEventListener(global.EE.EVENT_TYPES.BIKES, this.onBikes);
    global.EE.addEventListener(global.EE.EVENT_TYPES.SUB_VEH, this.handleNewPing);
  }

  componentWillUnmount() {
    global.EE.removeEventListener(global.EE.EVENT_TYPES.BIKES, this.onBikes);
    global.EE.removeEventListener(global.EE.EVENT_TYPES.SUB_VEH, this.handleNewPing);
    if (this.connectRef.current) this.connectRef.current.click();
  }

  onBikes = (bikes) => {
    this.vehicles = bikes.filter((bike) => bike.dev);
    if (this.vehicles.length === 1) this.onVehicleSelect(this.vehicles[0]);
    else this.forceUpdate();

    const vids = this.vehicles.map((veh) => veh.idx);
    global.gWebSocket.SendRequest({
      data: { a: "getDynamicLastSeen" , d: { veh: vids }},
      cb: (resp) => {
        const data = resp.d;
        if (data && data.length) {
          data.forEach((lastSeen) => {
            this.lastPingMap[lastSeen.vid] = lastSeen.ts;
          });
        }
      },
    });
  };

  getVehicleName = (veh) => {
    const vehName = (veh.vmk ? veh.vmk : "") + " " + (veh.mo ? veh.mo : "") + " " + (veh.reg ? veh.reg : veh.treg)

    const ts = this.lastPingMap[veh.idx] * 1000;
    const lastPing = `[${toLocaleDateString(ts)} ${timeFormat(ts, true)}]`;
    return vehName + " " + lastPing;
  }

  onVehicleSelect = async (vehicle) => {
    this.setState({ selectedVehicle: null }, () => {
      this.setState({ selectedVehicle: vehicle, pickerTitle: this.getVehicleName(vehicle) });
    });
  };

  handleNewPing = (payload) => {
    const ping = payload.obj;
    if (ping.ts && ping.ts > this.lastPingMap[ping.vid]) {
      this.lastPingMap[ping.vid] = ping.ts;
      this.updateLastPing(ping.vid, ping.ts);
    }
  };

  updateLastPing = (vid, ts) => {
    const veh = this.vehicles.find(({ idx }) => idx === vid);
    if (veh && this.state.selectedVehicle && this.state.selectedVehicle.idx === vid) {
      this.setState({ pickerTitle: this.getVehicleName(veh) });
    }
  }

  render() {
    return (
      <main>
        {this.vehicles && this.vehicles.length && (
          <Col lg={12} md={12} sm={12} xs={12} style={{ marginBottom: 16 }}>
            <p className="color-e1e1e1 font-size12px color-b5b5b5">Select Vehicle</p>
            <VehSingleDropDown vehicles={this.vehicles} onClick={(e) => this.onVehicleSelect(e)} title={this.state.pickerTitle} />
          </Col>
        )}

        <div className="dfu-main col-lg-12">
          {this.state.selectedVehicle && (
            <TesterPanel cypher={this.state.selectedVehicle.dev.cyp} defaultSelected={[ "toggleAT" ]} />
          )}
        </div>
      </main>
    );
  }
}
